import { Avatar, Box, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { isEmpty, uniqueId } from 'lodash'

import Colors from '#/styles/Colors'

const StyledAvatar = styled(Avatar)({
  fontSize: '0.8rem',
  height: '30px',
  width: '30px',
})

const TypePlansBadge = ({ value }) => {
  if (isEmpty(value)) return

  const avatars = {
    'cow-connect': {
      letter: 'CC',
      style: Colors.plan.cowconnect,
    },
    'monitoring': {
      letter: 'CM',
      style: Colors.plan.monitoring,
    },
  }

  const formattedValue = Array.isArray(value) ? value : [value]

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {formattedValue
        // Filtra nulos em planos
        ?.filter(({ status }) => status)
        ?.map(({ status, text }, index) => {
          const { letter, style } = avatars[status] ?? {}

          return (
            <Tooltip title={<span>{text}</span>} key={uniqueId(status + index)}>
              <StyledAvatar style={style}>{letter}</StyledAvatar>
            </Tooltip>
          )
        })}
    </Box>
  )
}

export default TypePlansBadge
